import { useTranslation } from "react-i18next";

import { PositionWrapper } from "@/modules/position";

import { getPositionCartesianMarker } from "./PositionCartesian.helper";
import "./PositionCartesian.style.less";

const PositionCartesian = ({ coordinates, imageSourceUrl }) => {
  const { t } = useTranslation();
  const marker = getPositionCartesianMarker({ coordinates });

  return (
    <PositionWrapper marker={marker} className="position-wrapper-cartesian">
      <img
        src={imageSourceUrl}
        className="cartesian-position-img"
        aria-label={t("global:datasetTypes.cartesian")}
      />
    </PositionWrapper>
  );
};

export default PositionCartesian;
